import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as L from "leaflet"
import { useRoot } from "../../../context/root";
import { useMap } from "../../../context/map";
import { iconHtml } from "./utils";

export const useMyLocation = () => {
  const location = useLocation();
  const routerNavigator = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const { mapRefresh, rootDispatch } = useRoot();
  const { mapContext } = useMap()
  const [position, setPosition] = useState<any>([]);
  const [hasPermission, setHasPermission] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    getUserLocation();
  }, [])

  const flyToMyLocation = () => {
    if (mapContext) {
      if (!hasPermission) {
        getUserLocation();
      }
      if (position.length > 0) {
        routerNavigator({
          pathname: `${process.env.REACT_APP_INTERNAL_URL}`,
          search: searchParams.toString()
        })
        mapContext.addLayer(L.marker(position, {
          icon: L.divIcon({
            className: 'abc',
            iconAnchor: [14, 14],
            html: iconHtml(),
          })
        }))
        rootDispatch({
          type: "setIsMapMoving",
          data: true
        })
        mapContext.flyTo(position, 13, { duration: 2 });
        mapContext.once("moveend", () => {
          rootDispatch({
            type: "setIsMapMoving",
            data: false
          })
          rootDispatch({
            type: "setDataList",
            data: []
          });
          rootDispatch({
            type: "setDataMarkers",
            data: []
          });
          rootDispatch({
            type: "setExtraMarker",
            data: null,
            mapContext
          });
          mapRefresh({ myLocation: true });
        })
      }
    }
  }

  const getUserLocation = () => {
    const geoLocation = navigator.geolocation;
    geoLocation.getCurrentPosition((res) => {
      setHasPermission(true);
      const { latitude, longitude } = res.coords;
      setPosition([latitude, longitude]);
      setShow(false);
    }, (err) => {
      setHasPermission(false);
      setShow(false)
    })
  }

  return {
    flyToMyLocation,
    position,
    hasPermission,
    show
  }
}
